import { render, staticRenderFns } from "./draggablePanel.vue?vue&type=template&id=5b6c69c8&"
import script from "./draggablePanel.vue?vue&type=script&lang=js&"
export * from "./draggablePanel.vue?vue&type=script&lang=js&"
import style0 from "./draggablePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports